import { render, staticRenderFns } from "./CarCard.vue?vue&type=template&id=02208490"
import script from "./CarCard.vue?vue&type=script&lang=js"
export * from "./CarCard.vue?vue&type=script&lang=js"
import style0 from "./CarCard.vue?vue&type=style&index=0&id=02208490&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports